export default __webpack_public_path__ + "media/color/drop-ad33e71f.svg";